import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

const PosterDashboard: React.FC = () => {
  const endpoint = '/posters';
  const title = 'Poster';

  const { projectHash, eventHash } = useParams<IParams>(); const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },

    hash: { ref: "hash", column: "hash", label: "Hash", show: true },
    email: { ref: "email", column: "email", label: "Email do autor", show: false },
    stars: { ref: "stars", column: "stars", label: "Stars", show: false },
    link_url: { ref: "link_url", column: "link_url", label: "Link", show: false },
    title: { ref: "title", column: "title", label: "Título", show: true },
    description: { ref: "description", column: "description", label: "Descritivo", show: false },
    author: { ref: "author", column: "author", label: "Autor" },
    co_authors: { ref: "co_authors", column: "co_authors", label: "Co-autores", show: false },
    category: { ref: "category", column: "category", label: "Forma de apresentação", show: false },
    video_type: { ref: "video_type", column: "video_type", label: "Tipo de Vídeo", show: false },
    video_id: { ref: "video_id", column: "video_id", label: "Video", show: false },
    image: { ref: "image", column: "image", label: "Poster", show: false },
    have_video: { ref: "have_video", column: "have_video", label: "Tem Video?", show: false },
    eixo: { ref: "eixo", column: "eixo", label: "Eixo temático", show: false },
    room_id: { ref: "room_id", column: "room_id", label: "Sala", show: false },
    date: { ref: "date", column: "date", label: "Data de apresentação", show: false },
    status: { ref: "status", column: "status", label: "Status", show: false },
    createdAt: { ref: "createdAt", column: "createdAt", label: "Criado em", show: true }


  };

  const formSchema = {

    title: { model: 'input', type: 'text', name: 'title', label: 'Título' },
    author: { model: 'input', type: 'text', name: 'author', label: 'Autores' },
    description: {
      model: 'richText',
      type: 'text',
      name: 'description',
      label: 'Descritivo',
    },


    status: {
      model: 'selectSimple',
      name: 'status_id',
      label: 'Status',
      defaultValue: 'yes',
      options: [
        { label: 'Sim', value: 'yes' },
        { label: 'Não', value: 'no' },
      ],
    },



    date: { model: 'datePickerHour', type: 'text', name: 'date', label: 'Data' },
    start_hour: {
      model: 'datePickerHour',
      type: 'text',
      name: 'start_hour',
      label: 'Hora de início',
      mask: 'hora',
    },
    end_hour: {
      model: 'datePickerHour',
      type: 'text',
      name: 'end_hour',
      label: 'Hora de Encerramento',
      mask: 'hora',
    },





    have_video: {
      model: 'selectSimple',
      name: 'have_video',
      label: 'É Vídeo',
      defaultValue: 'no',
      options: [
        { label: 'Sim', value: 'yes' },
        { label: 'Não', value: 'no' },
      ],
    },

    video_id: { model: 'input', type: 'text', name: 'video_id', label: 'ID do Vídeo' },
    video_type_id: {
      model: 'selectSimple',
      name: 'video_type_id',
      label: 'Tipo de Vídeo',
      defaultValue: 'vimeo',
      options: [
        { label: 'Vimeo', value: 'vimeo' },
        { label: 'Youtube', value: 'youtube' },
        { label: 'Zoom', value: 'zoom' },
        { label: 'On Demand', value: 'ondemand' },
        { label: 'Iframe', value: 'iframe' },
      ]

    },
  };

  const formSchemaUpdate = {
    image: {
      model: 'uploadImage',
      type: 'upload',
      name: 'image',
      label: 'Foto',
    },
    ...formSchema
  };

  const formValidation: Record<string, ValidationSchema> = {
    title: {
      name: 'title',
      type: 'string',
      label: 'Título',
      rules: [{ type: 'required' }],
    },
  };


  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default PosterDashboard;
